import { inject, Injectable } from '@angular/core';

import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';

import {
  CustomQuestionAnswer,
  HierarchicalRootQuestionResponse
} from '@ui/shared/model';

import {
  customQuestionsByPropertyQuery,
  hierarchicalRootQuestionResponseMutation,
  questionsAndAnswersByCustomerQuery,
  questionsByCustomerQuery,
  saveCustomQuestionResponsesMutation
} from '../queries/custom-questions.queries';

@Injectable({
  providedIn: 'root'
})
export class CustomQuestionFacade {
  private apollo = inject(Apollo);

  public getCustomQuestions(id: string) {
    return this.apollo
      .query({
        query: customQuestionsByPropertyQuery,
        variables: { id }
      })
      .pipe(map(res => res.data.customQuestionsByProperty));
  }

  public saveAnswers(input: CustomQuestionAnswer[]) {
    return this.apollo.mutate({
      mutation: saveCustomQuestionResponsesMutation,
      variables: { input }
    });
  }

  public getQuestionsByCustomer(id: string) {
    return this.apollo
      .query({
        query: questionsByCustomerQuery,
        variables: { id }
      })
      .pipe(map(res => res.data.questionsByCustomer));
  }

  public getQuestionsAndAnswersByCustomer(id: string) {
    return this.apollo
      .query({
        query: questionsAndAnswersByCustomerQuery,
        variables: { id }
      })
      .pipe(map(res => res.data.questionsAndAnswersByCustomer));
  }

  public hierarchicalRootQuestionResponse(
    input: HierarchicalRootQuestionResponse[]
  ) {
    return this.apollo
      .mutate({
        mutation: hierarchicalRootQuestionResponseMutation,
        variables: { input }
      })
      .pipe(map(response => response.data.hierarchicalRootQuestionResponse));
  }
}
